import { useQuery } from "@tanstack/react-query";
import { fetchProjectGroups } from "../services/projectsServices";

const useProjectGroups = (forSelection = false) => {
  return useQuery({
    queryKey: forSelection ? ["projectGroupsSelection"] : ["projectGroups"],
    queryFn: () => fetchProjectGroups(forSelection),
    staleTime: 5 * 60 * 1000, // Cache data for 5 minutes
  });
};

export default useProjectGroups;
